import { Provider } from "react-redux";
import Blogs from "./components/Blogs";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import SearchSection from "./components/SearchSection";
import store from "./redux/store";

function App() {
  return (
    <Provider store={store}>
      <div>
        <Navbar />
        <SearchSection />
        <Blogs />
        <Footer />
      </div>
    </Provider>
  );
}

export default App;
